"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const loadEticketModule = () => ({
    hasRouter: false,
    modules: [],
});
exports.default = loadEticketModule;
